// noinspection JSDeprecatedSymbols
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbModule } from 'primeng/breadcrumb';

import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { GlobalStore } from '@web/csl-lib-store';
import { MenuItem } from 'primeng/api';
import { startWith } from 'rxjs';

@Component({
  selector: 'app-home-breadcrumb',
  standalone: true,
  imports: [BreadcrumbModule],
  templateUrl: './home-breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home-breadcrumb.component.css',
})
export class HomeBreadcrumbComponent implements OnInit {

  /* Store */

  readonly globalStore = inject(GlobalStore);


  /* Services */

  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);


  /* Member Vars */

  breadcrumbMenuItems = signal<MenuItem[]>([]);
  readonly home = {icon: 'fa-solid fa-home fa-xl', routerLink: '/hr-index'};
  static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';

  /* Lifecycle Hooks */



  /* Event Handlers */

  ngOnInit(): void {

      this.router.events.pipe(
        startWith(this.router),
      ).subscribe(() => {
        this.breadcrumbMenuItems.set(this.createBreadcrumbs(this.activatedRoute, '', []));
      });
  }


  /* Instance Methods */

  // Builder method to create the breadcrumb item array
  createBreadcrumbs(route: ActivatedRoute, routerLink: string = '', breadcrumbs: MenuItem[] = []): MenuItem[] {

    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    // noinspection LoopStatementThatDoesntLoopJS
    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        routerLink += `/${routeURL}`;
      }

      const label = child.snapshot.data[HomeBreadcrumbComponent.ROUTE_DATA_BREADCRUMB];
      if(label !== null && label !== undefined) {
        breadcrumbs.push({label, routerLink});
      }

      return this.createBreadcrumbs(child, routerLink, breadcrumbs);
    }

    return this.breadcrumbMenuItems()
  }

}
